<script>
    import TopBar from "./TopBar.svelte"
</script>

<section>
<div class="home">
    <TopBar/>
    <div class="home__card">
        <div class="cardContainer" style="position:relative">
            <div class="card">
                <div class="card__text">
                    <span class="title">
                        Somos a <span style="color:#8C66C9;">VLGI Asset</span><br/>
                    </span>
                    <br/>
                    Soluções de gestão de carteiras administradas no Brasil e no exterior, fundos de investimento e fundos exclusivos. <br/>
                    <br/>
                    Desta forma, é possível trabalhar com um <span style="font-weight: bold;">número ilimitado de opções</span>, juntamente com o acompanhamento constante de acordo com a política de investimentos definida com <span style="color:#8C66C9; font-weight: bold;">você</span>.
                </div>
            </div>
            <!-- <div class="disclaimer">
                <p> *Disclaimer: A instituição está em processo de credenciamento na CVM e está em fase pré-operacional. </p>
            </div> -->
        </div>
    </div>
</div>
</section>

<style lang="scss">
    @use "../styles/variables" as v;

    .home {
        position: relative;
        min-height: 110vh;
        background: url('../Images/home_backover.png');
        background-size: cover;
        background-attachment: fixed;

        &__card{
            position: relative;
            padding: 0 1rem 8rem;

            .cardContainer {
                margin-top: 4rem;
            }

            .card {
                color: #333333;
                background: rgba(255, 255, 255, 0.59);
                box-sizing: border-box;
                backdrop-filter: blur(40px);
                border-radius: 30px;
                padding: 2em 1em;
                font-weight: 400;
                font-size: 1.714rem;
                z-index: 2;

                &__text {
                    .title {
                        font-size: 2.25rem;
                        font-weight: bold;
                    }
                }
            }
        }

        .disclaimer {
            padding: 2rem 0;

            p {
                font-weight: bold;
                font-style: italic;
            }
        }
    }


    @media only screen and (min-width: v.$tablet-devices) {
        .home {
            &__card{
                padding: 4rem;
            }
        }
    }

    @media only screen and (min-width: v.$md-desktop-devices) {
        .home {

            &__card{
                padding: 8rem 9.7rem;

                .cardContainer {
                    margin-top: 0;
                }

                .card{
                    width: 45%;
                    padding: 3.2rem 3rem;
                }
            }
        }
    }

</style>
